"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TYPES = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userflow = require("../../../constants/userflow");

var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));

var _HotelStars = _interopRequireDefault(require("../../HotelStars"));

var _WishlistItemDate = _interopRequireDefault(require("./WishlistItemDate"));

var TYPES;
exports.TYPES = TYPES;

(function (TYPES) {
  TYPES["SEARCH"] = "search";
  TYPES["HOTEL"] = "hotel";
  TYPES["PACKAGE"] = "package";
})(TYPES || (exports.TYPES = TYPES = {}));

var typesData = {
  search: {
    color: '#F5A623',
    title: 'Поиск'
  },
  hotel: {
    color: '#3E921C',
    title: 'Отель'
  },
  "package": {
    color: '#4A90E2',
    title: 'Тур'
  }
};

var WishlistItem = function WishlistItem(props) {
  var _onClick = props.onClick,
      id = props.id,
      link = props.link,
      stars = props.stars,
      hotelTitle = props.hotelTitle,
      image = props.image,
      type = props.type,
      rating = props.rating,
      price = props.price,
      date = props.date,
      nights = props.nights,
      flex = props.flex,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      onPackageClicked = props.onPackageClicked,
      onHotelClicked = props.onHotelClicked,
      hotelId = props.hotelId,
      packageId = props.packageId,
      searchType = props.searchType;

  var onCardClick = function onCardClick() {
    switch (type) {
      case 'hotel':
        if (hotelId) onHotelClicked(hotelId, searchType);
        break;

      case 'package':
        if (packageId) onPackageClicked(packageId, searchType);
        break;

      default:
    }
  };

  return /*#__PURE__*/_react["default"].createElement(StyledWishlistItem, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    href: link,
    onClick: onCardClick,
    target: "_blank",
    rel: "noreferrer",
    title: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435"
  }, image && /*#__PURE__*/_react["default"].createElement(Image, {
    image: image,
    type: type
  }), /*#__PURE__*/_react["default"].createElement(Content, null, /*#__PURE__*/_react["default"].createElement(Type, {
    type: type
  }, typesData[type].title, _userflow.NBSP, stars ? /*#__PURE__*/_react["default"].createElement(_HotelStars["default"], {
    value: stars,
    size: 10
  }) : null), /*#__PURE__*/_react["default"].createElement(Title, null, hotelTitle, rating ? /*#__PURE__*/_react["default"].createElement(Rating, null, rating) : null), /*#__PURE__*/_react["default"].createElement(_WishlistItemDate["default"], {
    date: date,
    nights: nights,
    flex: flex
  }), /*#__PURE__*/_react["default"].createElement(Price, null, type !== TYPES.PACKAGE && 'от ', /*#__PURE__*/_react["default"].createElement(StyledCurrencyFormat, {
    value: price
  }), /*#__PURE__*/_react["default"].createElement("small", null, "\u043D\u0430 \u0434\u0432\u043E\u0438\u0445")))), /*#__PURE__*/_react["default"].createElement(RemoveButton, {
    onClick: function onClick() {
      return _onClick(id);
    }
  }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"));
};

var Content = _styledComponents["default"].div.withConfig({
  displayName: "WishlistItem__Content",
  componentId: "sc-o5q6do-0"
})(["flex:1 1 0px;font-size:13px;margin-left:15px;padding-top:9px;padding-bottom:9px;border-bottom:1px solid #ddd;overflow:hidden;"]);

var StyledWishlistItem = _styledComponents["default"].li.withConfig({
  displayName: "WishlistItem__StyledWishlistItem",
  componentId: "sc-o5q6do-1"
})(["position:relative;background-color:#fff;padding:5px;height:103px;border-radius:2px;cursor:pointer;&:hover{background-color:rgba(0,0,0,0.05);button{display:block;}}&:last-child ", "{border:0;}"], Content);

var Link = _styledComponents["default"].a.withConfig({
  displayName: "WishlistItem__Link",
  componentId: "sc-o5q6do-2"
})(["padding:0;height:auto;line-height:normal;color:#000;white-space:nowrap;text-decoration:none;display:flex;"]);

var Image = _styledComponents["default"].div.withConfig({
  displayName: "WishlistItem__Image",
  componentId: "sc-o5q6do-3"
})(["position:relative;width:85px;height:85px;border-radius:100%;background-size:cover;background-position:center;background-repeat:no-repeat;", " &::after{content:'';position:absolute;position:absolute;top:0;right:0;width:23px;height:23px;color:#fff;background-color:#ccc;border:2px solid #fff;border-radius:100%;", "}"], function (_ref) {
  var image = _ref.image;
  return image && "\n  background-image: url(".concat(image, ");\n  ");
}, function (_ref2) {
  var type = _ref2.type;
  return type && "background-color: ".concat(typesData[type].color, ";");
});

var Type = _styledComponents["default"].div.withConfig({
  displayName: "WishlistItem__Type",
  componentId: "sc-o5q6do-4"
})(["display:flex;align-items:center;margin-bottom:2px;height:13px;font-size:0.9em;font-weight:bold;", ""], function (_ref3) {
  var type = _ref3.type;
  return type && "color: ".concat(typesData[type].color, ";");
});

var Title = _styledComponents["default"].div.withConfig({
  displayName: "WishlistItem__Title",
  componentId: "sc-o5q6do-5"
})(["position:relative;margin-bottom:5px;padding-right:30px;overflow:hidden;height:19px;font-size:1.2em;font-weight:bold;white-space:nowrap;text-overflow:ellipsis;"]);

var Rating = _styledComponents["default"].span.withConfig({
  displayName: "WishlistItem__Rating",
  componentId: "sc-o5q6do-6"
})(["position:absolute;top:0;right:0;padding:2px 5px 1px;font-size:0.8em;color:#fff;background-color:#5da80b;border-radius:2px;"]);

var Price = _styledComponents["default"].div.withConfig({
  displayName: "WishlistItem__Price",
  componentId: "sc-o5q6do-7"
})(["height:19px;font-size:1.2em;small{font-size:0.9em;}"]);

var RemoveButton = _styledComponents["default"].button.withConfig({
  displayName: "WishlistItem__RemoveButton",
  componentId: "sc-o5q6do-8"
})(["position:absolute;bottom:3px;right:3px;padding:0 10px;display:none;height:25px;font-size:0.8em;line-height:23px;color:#de2d00;border:1px solid #de2d00;border-radius:2px;background-color:transparent;cursor:pointer;&:hover{color:#fff;background-color:#de2d00;}"]);

var StyledCurrencyFormat = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "WishlistItem__StyledCurrencyFormat",
  componentId: "sc-o5q6do-9"
})(["font-weight:bold;padding-right:4px;"]);
var _default = WishlistItem;
exports["default"] = _default;